export default __webpack_public_path__ + "static/media/british flag learn english in ceret.391a5e7f.webp";